import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from "../../../shared/datatable/Datatable";
import { sitesList } from "../../../shared/settings/apiConfig";
import { PlusIcon } from "../../../shared/icons/Icons";

import '../home/Dashboard.scss';

export default function SiteList (props) {

    const customDate = (dataValue) => {
        if (!dataValue) return '- - -';
        const date = moment.utc(dataValue).local();
        return `${date.format('DD/MM/YYYY hh:mm:ss A')}`;
    };

    const dataTable = useRef(null);
    const [search, setSearch] = useState("");

    const [config, setConfig] = useState({
        name: 'sites',
        url: sitesList,
        columns: [
            { name: 'Name', property: 'name', sort: false, width: '20%' },
            { name: 'Location', property: 'location', sort: false, width: '30%' },
            { name: 'Description', property: 'description', sort: false, width: '30%' },
        ],
        field: ['id', 'name', 'location', 'description', 'created_at'],
        filter: [{ "field": "is_deleted", "value": false, "op": "=", "join": "AND" }],
        sort: [{ "field": "created_at", "direction": "desc" }],
        pagination: true,
        editLink: "/sites/edit/"
    });

    useEffect(() => {
        let filters = [];

        if (search?.trim()) {
            filters.push(
                { field: 'name', value: search, op: 'LIKE', join: 'OR' },
                { field: 'location', value: search, op: 'LIKE', join: 'OR' },
                { field: 'description', value: search, op: 'LIKE', join: 'OR' }
            );
        }

        if (filters.length > 0 && dataTable.current) {
            dataTable.current.searchData(filters);
        } else if (dataTable.current) {
            clearData();
        }
    }, [search]);

    const navigateToSite = () => {
        props.history.push('/sites/add');
    }

    const clearData = () => {
        dataTable.current?.searchData([]);
    }

    return(
        <div className="assignment-list main-content animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex flex-column">
                    <h3 className="content-label">Sites</h3>
                    <p className='content-sub-label fw-bold text-gray'>Manage construction sites and locations</p>
                </div>
                <div className="d-flex gap-3">
                    <div className="btn btn-solid-blue fw-bold" onClick={() => { navigateToSite() }}><PlusIcon /> Add Site</div>
                     
                </div>
            </div>

            <div className="activity-card user-input-section d-flex mt-3 p-3 gap-3">
                <InputGroup className="p-0 rounded">
                    <InputGroupText className="search" style={{ position: 'static' }} >
                        <i className="fa fa-search ml-3" ></i>
                    </InputGroupText>

                    <span className="icon-envelope-o"></span>
                    <Form.Control className={`search `} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"Search sites by name, location or description..."}
                        onChange={(event) => { setSearch(event.target.value) }}
                        value={search} />
                </InputGroup>
            </div>

            <Datatable ref={dataTable} config={config} viewType={'grid'} props={props} history={props.history} />
        </div>
    )
}